// extracted by mini-css-extract-plugin
export default {"Logo":"_Logo--MwAVR","CompanyName":"_CompanyName--D12JI"};